
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_10536_5311)","stroke":"#fff","stroke-width":".7","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M6.678 1.4l.449-.427a1.038 1.038 0 011.42-.01l.45.43a.927.927 0 01-.01 1.354l-.47.448M1.463 6.778l1.49 1.433"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M1.835 8.861l-1.49.425.442-1.433L1.835 8.86z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M1.142 6.688l5.502-5.284.941.904.956.891-5.502 5.285-2.694.802.797-2.598z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_10536_5311"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h10v10H0z"}})])])])
          )
        }
      }
    